import React, { Fragment, useEffect } from "react";
import { Router, Switch } from "react-router-dom";
import { useDispatch } from "react-redux";
import "./custom.scss";
import "./index.css";
import "bootstrap/dist/css/bootstrap.css";
import axios from "axios";
import { history } from "./helpers/history";

import { authProtectedRoutes, publicRoutes } from "./routes/routes";
import AppRoute from "./routes";

function App() {
  const DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN;

  axios.defaults.headers.common["x-access-token"] = localStorage.getItem(
    "access_token"
  )
    ? localStorage.getItem("access_token")
    : null;
  axios.defaults.headers.common["Authorization"] = localStorage.getItem(
    "access_token"
  )
    ? localStorage.getItem("access_token")
    : null;
  axios.defaults.headers.common["token"] = localStorage.getItem("access_token")
    ? localStorage.getItem("access_token")
    : null;

  //Case refresh / quit page :
  const dispatch = useDispatch();
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "Sure?";
      window.addEventListener("unload", function handler() {
        window.removeEventListener("unload", handler);

        sessionStorage.clear();
        dispatch(resetStatusList());
      });
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [dispatch]);
  return (
    <Router history={history}>
      <Fragment>
        <Switch>
          {publicRoutes.map((route, idx) => (
            <AppRoute
              path={route.path}
              component={route.component}
              key={idx}
              isAuthProtected={false}
            />
          ))}

          {authProtectedRoutes.map((route, idx) => (
            <AppRoute
              path={route.path}
              component={route.component}
              role={route.role}
              key={idx}
              isAuthProtected={true}
            />
          ))}
        </Switch>
      </Fragment>
    </Router>
  );
}

export default App;
